import { defineStyleConfig, defineStyle } from '@chakra-ui/react';

const bankSelect = defineStyle({
  field: {
    color: 'rentals.primary.txt',
    padding: '8px 16px 8px 16px',
    border: '1px solid #DFDEE2',
    borderRadius: '6px',
    _placeholder: {
      color: '#9F9DB0',
    },
  },
  addon: {
    color: 'rentals.primary.txt',
    padding: '8px 16px 8px 16px',
    border: '1px solid #DFDEE2',
    borderRadius: '6px',
  },
});

const Input = defineStyleConfig({
  variants: { bankSelect },
});

export default Input;
